var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"menuDropdown",staticClass:"menu-dropdown"},[_c('div',{staticClass:"arrow-up-set"}),_c('div',{staticClass:"menu-dropdown-content"},[_c('div',{staticClass:"padding-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }